import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';

import { CommonService, SystemIdType } from '../common/common.service';
import { User, UserSystemId } from '../user/user.model';
import { UserService } from '../user/user.service';

import { TranslationKeyMap } from './profile.i18n';

@Component({
    selector: 'cmps-profile-system-id',
    templateUrl: './system-id.profile.component.html',
})
export class SystemIdProfileComponent implements OnInit, OnDestroy {
    @Input()
    user: User;

    i18n = TranslationKeyMap;
    private _translateSub: Subscription;
    hasPendingData: boolean;
    systemIdTypeOpts: any[];

    constructor(
        private readonly _translateService: TranslateService,
        private readonly _commonService: CommonService,
        private readonly _userService: UserService,
    ) {}

    ngOnInit(): void {
        this._load();

        this._translateSub = this._translateService.onLangChange.subscribe(
            (event: LangChangeEvent) => this._load(),
        );
    }

    ngOnDestroy(): void {
        if (this._translateSub) {
            this._translateSub.unsubscribe();
        }
    }

    private _load(): void {
        this.hasPendingData = true;
        this.systemIdTypeOpts = [];
        this._commonService
            .listSystemIdTypes()
            .pipe(
                map((systemIdTypes: SystemIdType[]) => {
                    systemIdTypes.forEach((value) =>
                        this.systemIdTypeOpts.push({
                            label: value.label,
                            value: value.id,
                        }),
                    );
                }),
                concatMap(() =>
                    this._userService
                        .listSystemIds(this.user.id)
                        // eslint-disable-next-line no-return-assign
                        .pipe(
                            map(
                                (systemIds: UserSystemId[]) =>
                                    (this.user.systemIds = systemIds),
                            ),
                        ),
                ),
            )
            .subscribe(
                () => null,
                // eslint-disable-next-line n/handle-callback-err, no-return-assign
                (error) => (this.hasPendingData = false),
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
            );
    }
}
